/* HYPPE — "Customize your can" builder. Vanilla JS, no dependencies.
   Cart: one POST to /cart/add.js (can line + optional linked engraving line sharing one _engrave_id),
   then the theme's own <cart-drawer>.renderContents(...) opens the drawer (same path as the theme's product-form). */
(function () {
  'use strict';

  var UID = 0;
  var MAX = 30;
  var ALLOWED = /^[A-Z0-9 &.'\-]*$/;
  // Engraved back text uses the theme's heading font (Bayon) through its own CSS variable; nothing is loaded here.
  function headingFamily() {
    var v = '';
    try { v = getComputedStyle(document.documentElement).getPropertyValue('--font-heading-family').trim(); } catch (e) { v = ''; }
    return v || 'sans-serif';
  }
  function fontSpec() { return '32px ' + headingFamily(); }

  var COPY = {
    invalid: "Use only letters, numbers, spaces & . ' -",
    tooLong: 'Use 30 characters or fewer.',
    blocked: 'This wording can\u2019t be engraved.',
    addFail: 'Couldn\u2019t add your can. Try again.',
    added: 'Can added to cart.',
    adding: 'Adding\u2026',
    add: 'Add to cart',
    soldOut: 'Out of stock',
    unavailable: 'Unavailable',
    previewFail: 'Preview unavailable. ',
    ackNeeded: 'Tick the box to add your can.'
  };

  /* ---------- Blocked-wording filter ----------
     Word-boundary aware: the text is upper-cased, leetspeak-normalised (0>O 1>I 3>E 4>A 5>S $>S),
     split on every non-alphanumeric, and each whole word is compared (plus common suffixes and
     single-letter runs such as "F U C K"). Substrings inside other words ("class", "Scunthorpe") are NOT matched.
     The merchant-supplied server-side policy remains the authority; edit BLOCKED to tune the client list. */
  var BLOCKED = [
    'FUCK', 'FUCKIN', 'MOTHERFUCKER', 'MOTHERFUCKING', 'SHIT', 'BULLSHIT', 'BITCH', 'CUNT', 'DICK', 'COCK', 'PUSSY',
    'ASS', 'ASSHOLE', 'ARSE', 'ARSEHOLE', 'BASTARD', 'WHORE', 'SLUT', 'SKANK', 'TWAT', 'WANK', 'WANKER', 'PRICK',
    'PISS', 'CUM', 'JIZZ', 'TITS', 'BOOBS', 'PENIS', 'VAGINA', 'DILDO', 'ANAL', 'ANUS', 'BLOWJOB', 'HANDJOB',
    'NIGGER', 'NIGGA', 'NIGGAH', 'FAGGOT', 'FAG', 'KIKE', 'SPIC', 'CHINK', 'GOOK', 'WETBACK', 'BEANER', 'COON',
    'TRANNY', 'RETARD', 'RETARDED', 'PAKI', 'NAZI', 'HITLER', 'HEIL', 'KKK', 'RAPE', 'RAPIST', 'PEDO', 'PEDOPHILE',
    'MOLESTER'
  ];
  var SUFFIXES = ['', 'S', 'ES', 'ED', 'ER', 'ERS', 'ING', 'Y', 'Z'];
  var BLOCK_SET = {};
  var BLOCK_COLLAPSED = {};
  BLOCKED.forEach(function (w) {
    SUFFIXES.forEach(function (s) {
      BLOCK_SET[w + s] = true;
      if (collapse(w + s).length >= 3) BLOCK_COLLAPSED[collapse(w + s)] = true;
    });
  });
  var RAW_CODES = { '1488': true };
  var LEET = { '0': 'O', '1': 'I', '3': 'E', '4': 'A', '5': 'S', '$': 'S' };

  function collapse(s) { return s.replace(/(.)\1+/g, '$1'); }
  // "FUUUCK" / "ASSSS": only words that actually contain a repeated letter are compared in collapsed form,
  // so "BOBS" never matches "BOOBS".
  function stretched(t) {
    if (!/(.)\1/.test(t)) return false;
    if (BLOCK_SET[t.replace(/(.)\1{2,}/g, '$1$1')]) return true;
    var c = collapse(t);
    return c.length >= 3 && !!BLOCK_COLLAPSED[c];
  }

  function isBlocked(text) {
    var up = String(text).toUpperCase();
    var rawTokens = up.split(/[^A-Z0-9$]+/).filter(Boolean);
    for (var r = 0; r < rawTokens.length; r++) if (RAW_CODES[rawTokens[r]]) return true;
    var norm = up.replace(/[0134$5]/g, function (c) { return LEET[c]; });
    var tokens = norm.split(/[^A-Z]+/).filter(Boolean);
    var i;
    for (i = 0; i < tokens.length; i++) {
      var t = tokens[i];
      if (BLOCK_SET[t]) return true;
      if (stretched(t)) return true;
    }
    // runs of single letters: "F U C K", "F.U.C.K"
    var run = '';
    for (i = 0; i <= tokens.length; i++) {
      if (i < tokens.length && tokens[i].length === 1) { run += tokens[i]; continue; }
      if (run.length >= 3 && (BLOCK_SET[run] || stretched(run))) return true;
      run = '';
    }
    // whole entry with separators removed ("FU CK", "SH-IT")
    var joined = tokens.join('');
    if (joined && (BLOCK_SET[joined] || stretched(joined))) return true;
    return false;
  }

  function validate(trimmed) {
    if (!trimmed) return { ok: true };
    if (!ALLOWED.test(trimmed)) return { ok: false, msg: COPY.invalid };
    if (trimmed.length > MAX) return { ok: false, msg: COPY.tooLong };
    if (isBlocked(trimmed)) return { ok: false, msg: COPY.blocked };
    return { ok: true };
  }

  function normalise(v) {
    return String(v)
      .toUpperCase()
      .replace(/[\u2018\u2019\u02BC]/g, "'")
      .replace(/[\u2013\u2014\u2212]/g, '-')
      .replace(/\u00A0/g, ' ');
  }

  function rand6() {
    var s = '';
    var chars = '0123456789abcdefghijklmnopqrstuvwxyz';
    var buf = null;
    try { buf = new Uint8Array(6); (window.crypto || window.msCrypto).getRandomValues(buf); } catch (e) { buf = null; }
    for (var i = 0; i < 6; i++) s += chars[(buf ? buf[i] : Math.floor(Math.random() * 256)) % 36];
    return s;
  }

  function scopeIds(markup, prefix) {
    var ids = [];
    markup.replace(/\sid="([^"]+)"/g, function (m, id) { ids.push(id); return m; });
    ids.forEach(function (id) {
      markup = markup.split('id="' + id + '"').join('id="' + prefix + id + '"');
      markup = markup.split('url(#' + id + ')').join('url(#' + prefix + id + ')');
    });
    return markup;
  }

  function init(root) {
    if (root.__ccInit) return;
    root.__ccInit = true;

    var uid = 'cc' + (++UID);
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var els = {
      tabs: $$('[data-cc-tab]'),
      panels: { front: $('[data-cc-panel="front"]'), back: $('[data-cc-panel="back"]') },
      discs: { front: $('[data-cc-disc="front"]'), back: $('[data-cc-disc="back"]') },
      msg: $('[data-cc-previewmsg]'),
      fontMsg: $('[data-cc-fontmsg]'),
      form: $('[data-cc-form]'),
      text: $('[data-cc-text]'),
      count: $('[data-cc-count]'),
      err: $('[data-cc-err]'),
      status: $('[data-cc-status]'),
      colourName: $('[data-cc-colourname]'),
      presetName: $('[data-cc-presetname]'),
      ack: $('[data-cc-ack]'),
      add: $('[data-cc-add]'),
      addMsg: $('[data-cc-addmsg]'),
      live: $('[data-cc-live]')
    };

    var data = null;
    try { data = JSON.parse($('script[data-cc-data]').textContent); } catch (e) { data = null; }

    var presets = {};
    $$('template[data-cc-preset]').forEach(function (t) { presets[t.getAttribute('data-cc-preset')] = t.innerHTML; });

    var state = {
      variantId: null,
      key: 'black',
      label: 'Black',
      preset: '0',
      presetName: 'HYPPE Logo',
      side: 'front',
      font: 'pending',
      busy: false,
      pendingId: null,
      attempted: false
    };

    var fmt = function (cents) {
      var cur = (data && data.currency) || 'USD';
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency', currency: cur,
          minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2
        }).format(cents / 100);
      } catch (e) {
        return '$' + (cents % 100 ? (cents / 100).toFixed(2) : String(cents / 100));
      }
    };

    // Colour names always come from the variant title (data.variants[].title); data-label (also the Liquid variant title) is the fallback.
    function colourTitle(r) {
      var v = variantById(r.value);
      return (v && v.title) || r.getAttribute('data-label') || r.value;
    }

    function variantById(id) {
      var list = (data && data.variants) || [];
      for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i];
      return null;
    }

    /* ---------- shared gradient defs (one set per instance; unique IDs) ---------- */
    function buildDefs() {
      var d = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      d.setAttribute('class', 'cc-defs');
      d.setAttribute('aria-hidden', 'true');
      d.setAttribute('focusable', 'false');
      d.innerHTML =
        '<defs>' +
        '<radialGradient id="' + uid + '-lid" cx="0.36" cy="0.3" r="0.85">' +
        '<stop offset="0" style="stop-color:var(--cc-light)"/><stop offset="0.55" style="stop-color:var(--cc-base)"/><stop offset="1" style="stop-color:var(--cc-dark)"/></radialGradient>' +
        '<linearGradient id="' + uid + '-rim" x1="0" y1="0" x2="1" y2="1">' +
        '<stop offset="0" stop-color="#ffffff" stop-opacity="0.75"/><stop offset="0.5" stop-color="#ffffff" stop-opacity="0.12"/><stop offset="1" stop-color="#ffffff" stop-opacity="0.5"/></linearGradient>' +
        '<linearGradient id="' + uid + '-sheen" x1="0" y1="0" x2="1" y2="1">' +
        '<stop offset="0" stop-color="#ffffff" stop-opacity="0.16"/><stop offset="0.45" stop-color="#ffffff" stop-opacity="0"/><stop offset="1" stop-color="#000000" stop-opacity="0.18"/></linearGradient>' +
        '</defs>';
      root.appendChild(d);
    }

    // Radial spun finish (conic highlight lobes), drawn once; visible only when --cc-spin = 1 (camo). Pure geometry, no ids.
    var SPIN = '';
    (function () {
      var N = 90, R = 184;
      function pt(a) { return (200 + R * Math.cos(a)).toFixed(2) + ',' + (200 + R * Math.sin(a)).toFixed(2); }
      for (var i = 0; i < N; i++) {
        var a0 = (i / N) * 2 * Math.PI, a1 = ((i + 1.4) / N) * 2 * Math.PI, mid = (a0 + a1) / 2;
        var v = Math.cos(2 * (mid - 0.9)) * 0.7 + Math.cos(6 * (mid - 0.3)) * 0.3; // two broad lobes + fine brushing
        var fill = v >= 0 ? '#ffffff' : '#000000', op = Math.min(0.2, Math.abs(v) * 0.2).toFixed(3);
        SPIN += '<path d="M200,200 L' + pt(a0) + ' A' + R + ',' + R + ' 0 0 1 ' + pt(a1) + ' Z" fill="' + fill + '" opacity="' + op + '"/>';
      }
    })();
    function lidBase() {
      return '<circle cx="200" cy="200" r="184" fill="url(#' + uid + '-lid)"/>' +
        '<circle cx="200" cy="200" r="184" fill="url(#' + uid + '-sheen)"/>' +
        '<g style="opacity:var(--cc-spin,0)">' + SPIN + '</g>' +
        '<circle cx="200" cy="200" r="179.5" fill="none" stroke="var(--cc-rim)" stroke-width="9" style="opacity:var(--cc-spin,0)"/>' +
        '<path d="M70 92 A176 176 0 0 1 150 33" fill="none" stroke="#ffffff" stroke-width="1.4" stroke-linecap="round" style="opacity:calc(var(--cc-spin,0) * 0.55)"/>' +
        '<circle cx="200" cy="200" r="182.5" fill="none" stroke="url(#' + uid + '-rim)" stroke-width="3"/>' +
        '<circle cx="200" cy="200" r="177" fill="none" stroke="rgba(0,0,0,0.28)" stroke-width="1"/>' +
        '<circle cx="200" cy="200" r="174" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="1"/>';
    }

    function art(idx, prefix) {
      var raw = presets[idx];
      if (!raw) throw new Error('preset ' + idx + ' missing');
      var inner = raw
        .replace(/^[\s\S]*?<svg[^>]*>/i, '')
        .replace(/<\/svg>[\s\S]*$/i, '')
        .replace(/<title[\s\S]*?<\/title>/gi, '')
        .replace(/<desc[\s\S]*?<\/desc>/gi, '')
        .replace(/<!--[\s\S]*?-->/g, '');
      return '<g class="cc-ink"><g fill="currentColor">' + scopeIds(inner, prefix) + '</g></g>';
    }

    function discSvgInner(idx, prefix) { return lidBase() + art(idx, prefix); }

    /* ---------- rendering ---------- */
    var renderedFront = '';
    function renderFront() {
      if (renderedFront !== state.preset) {
        els.discs.front.innerHTML = discSvgInner(state.preset, uid + 'f-');
        renderedFront = state.preset;
      }
      els.discs.front.setAttribute('aria-label', state.presetName + ' front design on a ' + state.label + ' can lid');
    }

    function renderThumbs() {
      $$('[data-cc-thumb]').forEach(function (el) {
        var idx = el.getAttribute('data-cc-thumb');
        el.innerHTML = '<svg viewBox="0 0 400 400" focusable="false" aria-hidden="true">' + discSvgInner(idx, uid + 't' + idx + '-') + '</svg>';
      });
    }

    var backBuilt = false;
    function renderBack() {
      if (!backBuilt) {
        els.discs.back.innerHTML = lidBase() +
          '<text class="cc-back-text" x="200" y="200" font-size="32" letter-spacing="1.3" data-cc-backtext></text>' +
          '<text class="cc-back-text cc-back-ghost" x="200" y="200" font-size="32" letter-spacing="1.3" aria-hidden="true">YOUR TEXT</text>'; /* atlas-mobile-typing: ghost */
        backBuilt = true;
      }
      var textEl = els.discs.back.querySelector('[data-cc-backtext]');
      var t = trimmedText();
      var ready = state.font === 'ready';
      var show = t; /* atlas: always show live text; re-measured when the font loads */
      textEl.style.visibility = 'visible';
      var ghostEl = els.discs.back.querySelector('.cc-back-ghost'); if (ghostEl) ghostEl.style.visibility = t ? 'hidden' : 'visible'; /* atlas-mobile-typing */
      /* atlas-30: one line while it stays >=24px, otherwise two lines split at the space nearest the middle */
      var spacing0 = 1.3, lines = show ? [show] : [];
      if (show && show.length > 1 && measure(show, spacing0) * 24 / 32 > 280) {
        var mid = show.length / 2, cut = -1;
        for (var i = 1; i < show.length - 1; i++) if (show[i] === ' ' && (cut < 0 || Math.abs(i - mid) < Math.abs(cut - mid))) cut = i;
        lines = cut > 0 ? [show.slice(0, cut).trim(), show.slice(cut + 1).trim()] : [show.slice(0, Math.ceil(mid)), show.slice(Math.ceil(mid))];
      }
      var maxW = lines.length > 1 ? 250 : 280, size = 32, spacing = spacing0, w = 0;
      lines.forEach(function (ln) { w = Math.max(w, measure(ln, spacing0)); });
      if (w > maxW) { size = 32 * maxW / w; spacing = spacing0 * size / 32; }
      while (textEl.firstChild) textEl.removeChild(textEl.firstChild);
      if (lines.length === 1) textEl.textContent = lines[0];
      else lines.forEach(function (ln, k) {
        var ts = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
        ts.setAttribute('x', '200');
        ts.setAttribute('dy', String(Math.round((k === 0 ? -0.6 : 1.2) * size * 100) / 100));
        ts.textContent = ln;
        textEl.appendChild(ts);
      });
      textEl.setAttribute('font-size', String(Math.round(size * 100) / 100));
      textEl.setAttribute('y', String(backCenterY()));
      textEl.setAttribute('letter-spacing', String(Math.round(spacing * 100) / 100));
      els.discs.back.setAttribute('aria-label', state.label + ' can lid back, ' + (show ? 'engraved ' + show : 'no engraving'));
    }

    // Back-text vertical centre (SVG units, 200 = lid centre). Single token: CSS custom property --cc-back-y on .cc.
    // Provisional (engraving location not confirmed): lower part of the Back view.
    function backCenterY() {
      var v = parseFloat(getComputedStyle(root).getPropertyValue('--cc-back-y'));
      return isFinite(v) ? v : 200;
    }

    var canvas = null;
    function measure(text, spacing) {
      try {
        canvas = canvas || document.createElement('canvas').getContext('2d');
        canvas.font = fontSpec();
        return canvas.measureText(text).width + spacing * text.length;
      } catch (e) {
        return text.length * 20;
      }
    }

    /* ---------- tabs ---------- */
    function setTab(name, opts) {
      state.side = name;
      els.tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-cc-tab') === name;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        if (on && opts && opts.focus) tab.focus();
      });
      els.panels.front.hidden = name !== 'front';
      els.panels.back.hidden = name !== 'back';
    }

    els.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { setTab(tab.getAttribute('data-cc-tab'), { focus: false }); });
      tab.addEventListener('keydown', function (e) {
        var order = els.tabs.map(function (t) { return t.getAttribute('data-cc-tab'); });
        var i = order.indexOf(tab.getAttribute('data-cc-tab'));
        var n = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = order[(i + 1) % order.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = order[(i - 1 + order.length) % order.length];
        else if (e.key === 'Home') n = order[0];
        else if (e.key === 'End') n = order[order.length - 1];
        if (n) { e.preventDefault(); setTab(n, { focus: true }); }
      });
    });

    /* ---------- state -> UI ---------- */
    function trimmedText() { return els.text.value.trim(); }

    function hasDesign() { return String(state.preset) !== '0'; } /* atlas-design-addon: preset 0 = plain HYPPE logo, no add-on */
    function canAdd() {
      var v = variantById(state.variantId);
      var t = trimmedText();
      if (!v || !v.available || !(v.price > 0)) return false;
      if (!els.ack.checked) return false;
      if (hasDesign() && !(data && data.design && data.design.variantId)) return false;
      if (!validate(t).ok) return false;
      return true;
    }

    function update() {
      var t = trimmedText();
      var res = validate(t);
      var v = variantById(state.variantId);
      var priceOk = v && v.price > 0;
      var engCents = (data && data.engrave && data.engrave.price) || 0;
      var desCents = hasDesign() ? ((data && data.design && data.design.price) || 0) : 0; /* atlas-design-addon */

      els.count.textContent = t.length + '/' + MAX;
      els.err.textContent = res.ok ? '' : res.msg;
      syncStatus();
      if (res.ok) els.text.removeAttribute('aria-invalid'); else els.text.setAttribute('aria-invalid', 'true');

      var fontBad = false; /* atlas: never block or warn on font load */
      els.fontMsg.hidden = !fontBad;

      var label = priceOk ? COPY.add + ' \u00b7 ' + fmt(v.price + desCents + (t ? engCents : 0)) : COPY.add;
      if (state.busy) label = COPY.adding;
      else if (!v || !v.available) label = COPY.soldOut;
      else if (!priceOk) label = COPY.unavailable;
      els.add.textContent = label;
      els.add.setAttribute('aria-disabled', canAdd() && !state.busy ? 'false' : 'true');
      if (state.busy) els.add.setAttribute('aria-busy', 'true'); else els.add.removeAttribute('aria-busy');

      els.colourName.textContent = state.label;
      els.presetName.textContent = state.presetName + (hasDesign() ? ' \u00b7 +' + fmt((data.design && data.design.price) || 0) : ''); /* atlas-design-addon */

      renderBack();
    }

    function announce(text) {
      els.live.textContent = '';
      setTimeout(function () { els.live.textContent = text; }, 30);
    }

    /* ---------- one shared status slot (hint / text error / add message): fixed height, so it never moves anything ---------- */
    function syncStatus() {
      var mode = els.addMsg.textContent ? 'add' : (els.err.textContent ? 'err' : 'hint');
      els.status.setAttribute('data-show', mode);
    }
    function setAddMsg(text) { els.addMsg.textContent = text; syncStatus(); }

    /* ---------- inputs ---------- */
    $$('input[type="radio"][data-key]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) selectVariant(r); });
    });
    function selectVariant(r) {
      state.variantId = r.value;
      state.key = r.getAttribute('data-key');
      state.label = colourTitle(r);
      root.setAttribute('data-finish', state.key);
      state.pendingId = null;
      setAddMsg('');
      renderFront();
      update();
    }

    $$('input[type="radio"][data-preset]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        state.preset = r.getAttribute('data-preset');
        state.presetName = r.value;
        state.pendingId = null;
        setAddMsg('');
        setTab('front', { focus: false });
        try { renderFront(); } catch (e) { previewFail(); return; }
        update();
      });
    });

    els.text.addEventListener('input', function () {
      var pos = els.text.selectionStart;
      var v = normalise(els.text.value).slice(0, MAX); // hard limit even for programmatic/paste input
      if (v !== els.text.value) {
        els.text.value = v;
        try { els.text.setSelectionRange(pos, pos); } catch (e) { /* noop */ }
      }
      state.pendingId = null;
      setAddMsg('');
      update();
    });
    els.text.addEventListener('input', function () { if (els.text.value.trim() && els.panels.back.hidden) setTab('back', { focus: false }); }); /* atlas: no change on tap; show Back once they type */
    els.text.addEventListener('blur', function () {
      var tr = els.text.value.trim();
      if (tr !== els.text.value) els.text.value = tr;
      update();
    });

    els.ack.addEventListener('change', function () { els.status.removeAttribute('data-attn'); setAddMsg(''); update(); });

    /* ---------- font readiness (theme heading font; already loaded by the theme) ---------- */
    function loadFont() {
      state.font = 'pending';
      update();
      if (!document.fonts || !document.fonts.load) { state.font = 'ready'; update(); return; }
      var timeout = new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, 6000); });
      // load() resolves (possibly with no faces) for system/fallback stacks and rejects only when a declared face fails.
      Promise.race([document.fonts.load(fontSpec(), 'ABC 012'), timeout]).then(function () {
        return document.fonts.ready;
      }).then(function () {
        state.font = 'ready';
        update();
      }).then(function () { fontFails = 0; }).catch(function () {
        // Retry quietly with backoff; only surface the message after repeated failures.
        fontFails++;
        if (fontFails < 3) { state.font = 'pending'; setTimeout(loadFont, fontFails * 1500); return; }
        state.font = 'failed';
        update();
      });
    }
    var fontFails = 0, fontDebounce = null;
    // Typing after a failure re-checks the font after a short pause instead of leaving the message up.
    els.text.addEventListener('input', function () {
      if (state.font !== 'failed') return;
      clearTimeout(fontDebounce);
      fontDebounce = setTimeout(function () { fontFails = 0; loadFont(); }, 400);
    });
    var fontRetry = $('[data-cc-fontretry]');
    if (fontRetry) fontRetry.addEventListener('click', loadFont);

    /* ---------- add to cart ---------- */
    function buildItems(id) {
      var t = trimmedText();
      var props = { 'Design': state.presetName, '_engrave_id': id };
      if (t) props['Back text'] = t;
      var items = [{ id: Number(state.variantId), quantity: 1, properties: props }];
      // Shopify lists the last item of a multi-item add first, so the engraving goes first in the
      // payload to appear UNDER its can in the cart drawer.
      if (t) items.unshift({
        id: Number(data.engrave.variantId),
        quantity: 1,
        properties: { '_engrave_id': id, '_linked_to': String(state.variantId) }
      });
      // atlas-design-addon: $5 design line, linked the same way (shown under the can, before back text)
      if (hasDesign()) items.unshift({
        id: Number(data.design.variantId),
        quantity: 1,
        properties: { '_engrave_id': id, '_linked_to': String(state.variantId) }
      });
      return items;
    }

    function drawerEl() { return document.querySelector('cart-drawer'); }

    function sectionIds() {
      var ids = ['cart-drawer', 'cart-icon-bubble'];
      var d = drawerEl();
      if (d && typeof d.getSectionsToRender === 'function') {
        try { ids = d.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) { /* keep default */ }
      }
      return ids;
    }

    function cartHas(id) {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          return (c.items || []).some(function (it) { return it.properties && it.properties._engrave_id === id; });
        })
        .catch(function () { return false; });
    }

    function postAdd(id) {
      var body = { items: buildItems(id), sections: sectionIds(), sections_url: window.location.pathname };
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok || (j && j.status)) throw new Error((j && (j.description || j.message)) || 'add failed');
          return j;
        });
      });
    }

    function openDrawer(resp) {
      var d = drawerEl();
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      if (!d || typeof d.renderContents !== 'function') { window.location.href = cartUrl; return Promise.resolve(); }
      var ready = resp && resp.sections ? Promise.resolve(resp) :
        fetch(cartUrl + '?sections=' + sectionIds().join(','))
          .then(function (r) { return r.json(); })
          .then(function (secs) { resp = resp || {}; resp.sections = secs; return resp; });
      return ready.then(function (r) {
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: state.variantId, cartData: r });
          }
        } catch (e) { /* theme pubsub optional */ }
        if (typeof d.setActiveElement === 'function') d.setActiveElement(document.activeElement || els.add);
        if (d.classList && d.classList.contains('is-empty')) d.classList.remove('is-empty'); // same as theme product-form; else open() traps focus on a null empty-state node
        d.renderContents(r);
        announce(COPY.added);
      }).catch(function () { window.location.href = cartUrl; });
    }

    function focusUnmet() {
      var t = trimmedText();
      if (!validate(t).ok) { els.text.focus(); return; }
      if (!els.ack.checked) {
        els.status.setAttribute('data-attn', 'true'); // everything is already on screen: focus only, no scrolling
        try { els.ack.focus({ preventScroll: true }); } catch (e) { els.ack.focus(); }
        return;
      }
    }

    function attempt() {
      if (state.busy) return;
      if (!canAdd()) {
        var vv = variantById(state.variantId), tt = trimmedText(), vr = validate(tt);
        setAddMsg((!vv || !vv.available) ? COPY.soldOut : (!vr.ok ? vr.msg : (!els.ack.checked ? COPY.ackNeeded : '')));
        focusUnmet(); return;
      }
      state.busy = true;
      setAddMsg('');
      update();
      var id = state.pendingId || ('eng_' + rand6());
      state.pendingId = id;
      var pre = state.attempted ? cartHas(id) : Promise.resolve(false);
      pre.then(function (already) { return already ? null : postAdd(id); })
        .then(function (resp) {
          state.pendingId = null;
          state.attempted = false;
          state.busy = false;
          update();
          return openDrawer(resp);
        })
        .catch(function () {
          state.attempted = true; // a retry first checks the cart for this _engrave_id, so it never duplicates
          state.busy = false;
          setAddMsg(COPY.addFail);
          update();
        });
    }

    els.form.addEventListener('submit', function (e) { e.preventDefault(); attempt(); });

    /* ---------- preview failure / retry ---------- */
    function previewFail() {
      els.msg.hidden = false;
      els.msg.innerHTML = '';
      els.msg.appendChild(document.createTextNode(COPY.previewFail));
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cc__link';
      b.textContent = 'Retry';
      b.addEventListener('click', function () { boot(true); });
      els.msg.appendChild(b);
    }

    function boot(isRetry) {
      try {
        if (!data || !data.variants || !data.variants.length) throw new Error('no data');
        if (!isRetry) buildDefs();
        var radios = $$('input[data-key]');
        // never auto-select an unavailable colour: first available wins; if none are available, show Sand (display only)
        var checked = root.querySelector('input[data-key]:checked:not(:disabled)') ||
          radios.filter(function (r) { return !r.disabled; })[0] ||
          radios.filter(function (r) { return r.getAttribute('data-key') === 'sand'; })[0] || radios[0];
        if (!checked) throw new Error('no variants');
        checked.checked = true;
        state.variantId = checked.value;
        state.key = checked.getAttribute('data-key');
        state.label = colourTitle(checked);
        root.setAttribute('data-finish', state.key);
        var pr = root.querySelector('input[data-preset]:checked');
        state.preset = pr.getAttribute('data-preset');
        state.presetName = pr.value;
        renderedFront = '';
        renderFront();
        renderThumbs();
        els.msg.hidden = true;
        if (!isRetry) { setTab('front', { focus: false }); loadFont(); }
        update();
      } catch (e) {
        previewFail();
      }
    }

    boot(false);
  }

  window.__cc = { isBlocked: isBlocked, validate: validate }; // read-only helpers (used by the test harness)

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cc]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

/* atlas-fit-guard 2026-10-06: never let the fixed-height one-screen box overflow onto the next block (seen on a real iPhone).
   If the content is taller than the box, add .cc__box--grow (CSS: height auto, compact preview). Re-checked on load, resize,
   orientation, bfcache restore, web-font load, and whenever any row changes size. */
(function () {
  var raf = 0;
  function typing() { var a = document.activeElement; return !!(a && a.closest && a.closest('.cc') && /^(INPUT|TEXTAREA)$/.test(a.tagName) && a.type !== 'checkbox' && a.type !== 'radio'); } /* atlas-kb-freeze */
  function fit() {
    raf = 0;
    if (typing()) return; /* atlas-kb-freeze: the keyboard must not flip the layout; re-checked on focusout */
    Array.prototype.forEach.call(document.querySelectorAll('.cc__box'), function (b) {
      b.classList.remove('cc__box--grow');
      if (window.innerWidth >= 900) return;
      if (b.scrollHeight > b.clientHeight + 1) b.classList.add('cc__box--grow');
    });
  }
  function soon() { if (!raf) raf = window.requestAnimationFrame(fit); }
  function watch() {
    fit();
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(soon);
      Array.prototype.forEach.call(document.querySelectorAll('.cc__box'), function (b) {
        ro.observe(b);
        Array.prototype.forEach.call(b.querySelectorAll(':scope > *, :scope > .cc__form > *'), function (el) { ro.observe(el); });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  window.addEventListener('load', soon);
  window.addEventListener('resize', soon);
  window.addEventListener('orientationchange', function () { setTimeout(soon, 250); });
  window.addEventListener('pageshow', soon);
  document.addEventListener('focusout', function () { setTimeout(soon, 500); }); /* atlas-kb-freeze */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(soon);
  document.addEventListener('shopify:section:load', watch);
})();
